import React from 'react';
import { Link } from 'react-router-dom';

const DropdownItem = (props) => {

    if (process.env.REACT_APP_DOCUMENTATION_MODE === props.mode || props.mode === "public")
    {
        return (
            <Link {...props} className="dropdown-item" />
        );
    }
    else
    {
        return null;
    }

}


export default DropdownItem;


// WEBPACK FOOTER //
// ./src/components/DropdownItem.js